// Copy and data for the FLEI 2026 exhibitor page. Kept apart from the component so
// the sales team's wording can be edited without touching layout code.
//
// Source: flei-landing-page-main/index.html (the static page the team designed).
// The wording is theirs and is kept as written; only the visual design changed.

export const EVENT = {
  name: "FLEI 2026",
  // The event has its own WhatsApp line, separate from the main Landhep number.
  waNumber: "6281311222357",
  mail: "info@landhep.id",
  // Apps Script web app bound to the leads sheet (source: ./apps-script.gs). Empty
  // means not deployed yet — the form then falls back to opening WhatsApp.
  sheetEndpoint: "https://script.google.com/macros/s/AKfycbxwakjDWYjmiQ9swHZ8PJ-GHhZpnobPp5WZjbzW4wEL8BGmelNRfqpnIlq4atm6AO8_/exec",
};

export const IMG = "/events/flei";

export const QUESTIONS = [
  "Mengapa saya harus memilih lokasi ini?",
  "Bagaimana peluang pasar lokasi ini?",
  "Mengapa lokasi saya tidak cocok?",
  "Adakah kompetitor atau daya tarik di lokasi ini?",
];

export const FEATURES = [
  {
    title: "Skor lokasi",
    body: "Bandingkan satu titik dengan titik lainnya di satu kota dan lihat area dengan skor kecocokan tertinggi untuk bisnis Anda.",
    img: "fitur-skor.jpg",
    alt: "Peta skor lokasi per sel grid untuk satu kategori bisnis di Jakarta Selatan.",
  },
  {
    title: "Profil demografi",
    body: "Kenali jumlah penduduk, komposisi gender, dan struktur usia dalam radius calon lokasi.",
    img: "fitur-demografi.jpg",
    alt: "Profil populasi dalam radius calon lokasi, termasuk gender dan struktur usia.",
  },
  {
    title: "Kompetitor sekitar",
    body: "Lihat pesaing terdekat, jarak, tingkat ancaman, dan keunggulan utama mereka.",
    img: "fitur-kompetitor.jpg",
    alt: "Peta dan daftar kompetitor terdekat beserta jarak dan tingkat ancaman.",
  },
  {
    title: "Titik aktivitas",
    body: "Pahami sebaran tempat di sekitar lokasi, dari kuliner dan ritel hingga kantor, sekolah, dan hunian.",
    img: "fitur-poi.jpg",
    alt: "Peta titik aktivitas di sekitar lokasi, dari kuliner dan ritel hingga kantor dan hunian.",
  },
];

export const INDUSTRIES = [
  ["Agriculture & Environment", "Cek akses pasar, kepadatan populasi, dan aktivitas di sekitar lahan atau gerai."],
  ["Automotive", "Lihat konsentrasi bengkel, dealer, dan arus kendaraan di calon lokasi."],
  ["Beauty & Wellness", "Petakan densitas salon, klinik kecantikan, dan profil konsumen sekitar."],
  ["Community & Religious", "Pahami sebaran komunitas, tempat ibadah, dan titik berkumpul penduduk."],
  ["Creative & Media", "Temukan area dengan aktivitas kreatif, kantor, dan pengunjung yang relevan."],
  ["Education", "Analisa kepadatan usia sekolah, hunian, dan fasilitas pendidikan sekitar."],
  ["Entertainment", "Lihat titik keramaian, hiburan, dan pola kunjungan di sekitar lokasi."],
  ["F&B", "Bandingkan skor lokasi, kompetitor kuliner, dan footfall calon outlet."],
  ["Financial Services", "Petakan area perkantoran, ritel, dan profil demografi nasabah potensial."],
  ["Health", "Cek sebaran fasilitas kesehatan, hunian, dan kebutuhan layanan di area."],
  ["Hospitality", "Lihat titik aktivitas wisatawan, perkantoran, dan kompetitor akomodasi."],
  ["Industrial", "Analisa aksesibilitas, kepadatan industri, dan aktivitas di kawasan."],
  ["Office", "Pahami konsentrasi perkantoran, pekerja, dan layanan pendukung sekitar."],
  ["Retail", "Bandingkan densitas ritel, profil konsumen, dan persaingan di radius lokasi."],
  ["Services", "Lihat permintaan layanan, hunian, dan kompetitor di area calon gerai."],
  ["Sports & Fitness", "Petakan fasilitas olahraga, hunian, dan minat aktivitas di sekitar lokasi."],
  ["Tech & Digital", "Cek ekosistem digital, perkantoran, dan profil talenta di calon lokasi."],
];

export const SIGNALS = [
  "Sinyal Mobilitas",
  "Sinyal Footfall",
  "Sinyal Demografi",
  "Sinyal Point Of Interest (POI)",
  "Sinyal Kepadatan Bisnis",
  "Sinyal Aksesibilitas",
];

export const PROOF = [
  ["100+", "Sinyal dan sumber data relevan"],
  ["Model", "dan analisa statistik"],
  ["Tim", "Dibangun oleh tim data scientist"],
];

export const TESTIMONIAL = {
  intro: "Landhep telah digunakan oleh salah satu franchise ayam terbesar di Indonesia, yang memiliki lebih dari 700 cabang:",
  quote: "Landhep memberikan rekomendasi yang benar-benar sesuai dengan kondisi di lapangan. Dengan akurasi hingga 100 meter, kami jadi lebih mudah menentukan lokasi prioritas untuk ekspansi bisnis F&B kami.",
  by: "Area Expansion Manager, Ayam Gepuk Pak Gembus",
};

// Hero demo card. Illustrative figures from the original design — the card says so.
export const DEMO = {
  score: { value: 84, area: "Kalibata", others: [["Lenteng Agung", 82], ["Grogol Utara", 82]] },
  demo: { total: "90.648", male: 50, female: 50, ages: [["0–14", 22], ["15–64", 61], ["65+", 17]] },
  comps: [["XYZ Pizza", "170 m", "Tinggi"], ["ABC Restaurant", "190 m", "Tinggi"], ["Kedai Rasa", "260 m", "Sedang"]],
};

// Candidate-site comparison beside the investor questions. Illustrative figures;
// x/y place each pin on the drawing (viewBox 420 × 230). C has the fewest rivals
// but the thinnest crowd, so the winner is not simply "least competition".
export const CANDIDATES = [
  { id: "A", x: 150, y: 132, score: 84, pop: "48,2 rb", comps: 3, footfall: "Tinggi" },
  { id: "B", x: 318, y: 72, score: 71, pop: "39,5 rb", comps: 7, footfall: "Sedang" },
  { id: "C", x: 330, y: 196, score: 58, pop: "27,1 rb", comps: 2, footfall: "Rendah" },
];
